function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M511.99994 511.99994m-511.99994 0a511.99994 511.99994 0 1 0 1023.99988 0 511.99994 511.99994 0 1 0-1023.99988 0Z",
  fill: "#F0F0F0",
  "p-id": 2332
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M105.839988 200.283977c-40.217995 52.325994-70.543992 112.635987-88.20199 178.153979h266.355969L105.839988 200.283977zM1006.361882 378.437956c-17.657998-65.515992-47.985994-125.825985-88.20199-178.151979l-178.149979 178.151979h266.351969zM17.637998 645.567924c17.659998 65.515992 47.985994 125.825985 88.20199 178.149979l178.147979-178.149979H17.637998zM823.715903 105.841988c-52.325994-40.217995-112.633987-70.543992-178.151979-88.20399v266.353969l178.151979-178.149979zM200.283977 918.157892c52.325994 40.217995 112.635987 70.543992 178.151979 88.20399V740.009913l-178.151979 178.147979zM378.433956 17.637998c-65.515992 17.659998-125.825985 47.985994-178.149979 88.20199l178.149979 178.149979V17.637998zM645.565924 1006.361882c65.515992-17.659998 125.825985-47.985994 178.149979-88.20199l-178.149979-178.149979v266.351969zM740.009913 645.567924l178.149979 178.151979c40.215995-52.323994 70.543992-112.635987 88.20199-178.151979H740.009913z",
  fill: "#0052B4",
  "p-id": 2333
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1019.665881 445.217948H578.783932V4.333999A517.111939 517.111939 0 0 0 511.99994 0c-22.637997 0-44.921995 1.488-66.781992 4.333999v440.881949H4.333999A517.111939 517.111939 0 0 0 0 511.99994c0 22.637997 1.488 44.921995 4.333999 66.781992h440.881949v440.883949a516.699939 516.699939 0 0 0 133.565984 0V578.783932h440.883949A517.065939 517.065939 0 0 0 1023.99988 511.99994c0-22.633997-1.488-44.921995-4.333999-66.781992z",
  fill: "#D80027",
  "p-id": 2334
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M645.565924 645.567924L874.037898 874.039898a513.27194 513.27194 0 0 0 30.095996-32.869997l-195.603977-195.603977h-62.963993v0.002zM378.433956 645.567924h-0.004L149.959982 874.037898a513.27194 513.27194 0 0 0 32.869997 30.095996l195.603977-195.607977v-62.957993zM378.433956 378.437956v-0.004L149.961982 149.959982a513.27194 513.27194 0 0 0-30.095996 32.869997l195.605977 195.605977h62.961993zM645.565924 378.437956L874.039898 149.961982a512.65594 512.65594 0 0 0-32.869997-30.093996l-195.603977 195.605977v62.963993z",
  fill: "#D80027",
  "p-id": 2335
});

var SvgEn = function SvgEn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1612520072104,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 2331,
    width: 18,
    height: 18,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/en.ad64eb36.svg";
export { ForwardRef as ReactComponent };